<template>
	<div class="data" v-if=" ! this.$store.state.loading">
		<div class="top-menu">
			<div class="top-menu-left">
				<div class="top-menu-left-client noGamification">
					<template v-if="endUser && endUser.client && endUser.client.logo">
						<img :src="$imgUrl(endUser.client.logo)">
					</template>

					<template v-if=" ! endUser || ! endUser.client || ! endUser.client.logo">
						<a href="https://nudgd.se/" target="_blank"><img :src="$imgUrl('qHGzEUxJReKSXsSFLhFwPODuxVL9d55of1JsrLC7.png')"></a>
						<a href="https://resvana.com/" style="position:relative; top:-13px; left:3px;" target="_blank"><img width="126" :src="$imgUrl('resvana-logo.png')"></a>
					</template>
				</div>
			</div>
		</div>

		<v-container class="py-md-12 mt-12 cards">
		    <v-row class="mt-3 mt-lg-6">
		    	<v-col cols="12" sm="6" lg="4" class="card" v-if="endUser">
		    		<v-card class="mx-auto">
		    		    <v-card-title>Hantera dina inställningar och dina personuppgifter</v-card-title>
		    		    <v-card-text>
		    		    	<p>Hej {{ endUser.first_name }}!</p>
		    		    	<p>Här kan du ställa in hur och om du vill att vi ska kontakta dig samt hur vi får hantera dina personuppgifter.</p>
		    		    </v-card-text>
		    		</v-card>
		    	</v-col>

		    	<v-col cols="12" sm="6" lg="4" class="card" v-if="endUser">
		    		<v-card class="mx-auto">
		    		    <v-card-title>Kontaktinställningar</v-card-title>
		    		    <v-card-text>
		    		    	<div style="font-style: italic; margin-bottom:15px;" v-if=" ! endUser.email && ! endUser.phone" v-html="__('data_contact_no_contact')"></div>

		    		    	<div v-if="endUser.email || endUser.phone">
    		    		    	<p>Följande kontaktvägar använder vi idag. Vill du inte ha fler utskick i en kanal, klicka bara ur krysset och klicka på spara. <span v-if="endUser.phone && endUser.mail">Du kan istället välja en annan kanal eller välja att inte ta emot några utskick alls.</span></p>
    		    				<p>Inställningarna för SMS/e-post gäller då till och med {{ scrubAt }} då dina personuppgifter anonymiseras och därmed tas bort ur våra system.</p>

    		    				<label class="checkbox-label" v-if="endUser.email"><input v-model="preference.email" type="checkbox"> Email <span v-if="endUser.email">till {{ endUser.email }}</span></label>
    		    				<label class="checkbox-label" v-if="endUser.phone"><input v-model="preference.phone" type="checkbox"> Telefon <span v-if="endUser.phone">till {{ endUser.phone }}</span></label>
		    		    	</div>

		    		    	<div>
		    		    		<label class="checkbox-label" v-if="endUser && endUser.googleMapsConsent !== null"><input v-model="preference.googleMapsConsent" type="checkbox"> Medgivande till Google Maps</label>

		    		    		<div class="nudgd-btn mt-8" :class="{processing: savingPreferences}" @click="savePreferences()">Spara</div>
		    		    	</div>
		    			</v-card-text>
		    		</v-card>
		    	</v-col>

		    	<v-col offset-lg="4" offset-sm="3" cols="12" sm="6" lg="4" class="card" v-if=" ! endUser">
		    		<v-card class="mx-auto">
		    		    <v-card-title>Kontaktinställningar</v-card-title>
		    		    <v-card-text>
		    		    	<p class="mb-8" v-html="__('data_contact_enter_contact', 'Fyll i din email eller ditt telefonnummer för att ställa in på vilka sätt du vill bli kontaktad.')"></p>

		    		    	<v-text-field v-model="email" hide-detail outlined label="E-mail"></v-text-field>
		    		    	<v-text-field class="mb-0" v-model="phone" hide-detail outlined label="Telefonnummer"></v-text-field>

		    				<div class="nudgd-btn mt-0" :class="{processing: savingPreferences}" @click="findSlug()">OK</div>

		    				<v-alert class="mt-8" icon="icon-service" v-if="slugError" dense type="error">Vi kunde hitta någon användare med uppgifterna.</v-alert>
		    			</v-card-text>
		    		</v-card>
		    	</v-col>

		    	<v-col cols="12" sm="6" lg="4" class="card" v-if="policy">
		    		<v-card class="mx-auto">
		    		    <v-card-title>Information om behandlingen</v-card-title>
		    		    <v-card-text>
							<div v-if="policy.intro_text" class="mb-5" v-html="policy.intro_text"></div>

		    		    	<div v-if="policy.purpose">
			    		    	<h4 class="mb-1">Ändamål</h4>
			    		    	<div v-html="policy.purpose"></div>
			    		    </div>

		    		    	<div class="mt-5" v-if="policy.responsible_person_name">
			    		    	<h4 class="mb-1">Personuppgiftsansvarig</h4>
			    		    	<div v-if="policy.responsible_person_name" v-html="policy.responsible_person_name"></div>
			    		    	<div v-if="policy.responsible_person_phone" v-html="policy.responsible_person_phone"></div>
			    		    	<div v-if="policy.responsible_person_email" v-html="policy.responsible_person_email"></div>
			    		    </div>

			    		    <div class="mt-5" v-if="policy.legal_basis_for_processing">
			    		    	Behandlingen har sin rättsliga grund i: <em v-html="__(policy.legal_basis_for_processing, policy.legal_basis_for_processing)"></em>
			    		    </div>

					     <div class="mt-5" v-if="policy.legal_explanation" v-html="policy.legal_explanation"></div>

			    		    <div class="mt-5" v-if="endUser && endUser.source">
			    		    	Källa för personuppgifterna: <em>{{ endUser.source }}</em>
			    		    </div>

		    		    	<div class="mt-5">
			    		    	<a href="https://www.imy.se/privatperson/utfora-arenden/lamna-ett-klagomal/" target="blank">Lämna klagomål om behandlingen</a>
			    		    	<p>Nudgd AB behandlar personuppgifterna på uppdrag av Personuppgiftsansvarig.</p>
			    		    </div>
		    			</v-card-text>
		    		</v-card>
		    	</v-col>

			<v-col cols="12" sm="6" lg="4" class="card" v-else>
		    		<v-card class="mx-auto">
		    		    <v-card-title>Information om behandlingen</v-card-title>
		    		    <v-card-text>
					<div class="mb-5">
						<a href="https://nudgd.se/om-nudgd/integritetspolicy/">S&aring; h&auml;r behandlar Nudgd personuppgifter</a>
					</div>

		    		    	<div>
			    		    	<h4 class="mb-1">Ändamål</h4>
			    		    	<div>
							<p>&Auml;ndam&aring;let med behandlingen &auml;r att kommunicera med, och uppmuntra mottagaren att v&auml;lja ett mer klimatv&auml;nligt ress&auml;tt i vardagen genom en personanpassad sida samt f&ouml;lja upp effekten av tj&auml;nsten med avseende p&aring; f&ouml;r&auml;ndrade resebeteenden.<br />
							<br />
							<strong>Uppgifter som behandlas:</strong></p>
							
							<ul>
								<li>Identifierings- och kontaktuppgifter: e-post och adress.</li>
								<li>Aktivitetsuppgifter: s&aring;som om och n&auml;r man bes&ouml;kt plattformen och enk&auml;ten, samt anv&auml;nt kartfunktionen.</li>
							</ul>
							
							<p><em>D&aring; du sj&auml;lv l&auml;mnar personuppgifter vid anv&auml;ndandet av tj&auml;nsten s&aring;som e-postadress eller adress f&ouml;r v&auml;gvisning i kartan, &auml;r Nudgd personuppgiftsansvarig f&ouml;r dessa och de <a href="https://nudgd.se/om-nudgd/integritetspolicy/">behandlas p&aring; f&ouml;ljande s&auml;tt av Nudgd AB</a>.</em></p>
						</div>
					</div>

		    		    	<div class="mt-5">
			    		    	<h4 class="mb-1">Personuppgiftsansvarig</h4>
			    		    	<div>Dataskyddsombud Nudgd</div>
			    		    	<div>+46 104 058 590</div>
			    		    	<div>legal@nudgd.se</div>
				    	</div>

			    		    <div class="mt-5">
			    		    	Behandlingen har sin rättsliga grund i: <em>Samtycke</em>
			    		    </div>

			    		    <div class="mt-5">
			    		    	<br>Behandlingen av personuppgifter baseras ditt samtycke, med målet att arbeta mot ett klimatneutralt samhälle. Du som användare kan lämna samtycke till behandlingen för att kunna använda vissa specifika delar av plattformen.
			    		    </div>

		    		    	<div class="mt-5">
			    		    	<a href="https://www.imy.se/privatperson/utfora-arenden/lamna-ett-klagomal/" target="blank">Lämna klagomål om behandlingen</a>
			    		    	<p>Nudgd AB behandlar personuppgifterna enligt vår <a href="https://nudgd.se/om-nudgd/integritetspolicy/">integrigetspolicy</a>.</p>
			    		    </div>
		    			</v-card-text>
		    		</v-card>
			</v-col>
	    
		    </v-row>
		</v-container>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'Vue',

	data() {
		return {
			endUser: null,
			scrubAt: null,
			policy: null,

			email: null,
			phone: null,

			preference: {
				email: false,
				phone: false,
				googleMapsConsent: false,
				cookies: false
			},

			savingPreferences: false,
			preferencesSaved: false,
			slugError: false
		}
	},

	methods: {
		findSlug() {
			this.savingPreferences = true
			this.slugError = false

			axios.get(this.$apiUrl + '/api/slug-for', {params: {email: this.email, phone: this.phone}}).then(res => {
				setTimeout(() => {
					this.savingPreferences = false

					if (res.data.slug) {
						this.$router.push({name: 'Data', params: {slug: res.data.slug}, query: this.$route.query})
						location.reload()
					} else {
						this.slugError = true
					}
				}, 200)
			})
		},

		savePreferences() {
			let preference = []
			if (this.preference.email) { preference.push('email') }
			if (this.preference.phone) { preference.push('phone') }

			if (preference.length === 0) { preference.push('none') }

			this.savingPreferences = true
			this.preferencesSaved = false

			axios.post(this.$apiUrl + '/api/data', {
				slug: this.endUser.slug, preference, googleMapsConsent: this.preference?.googleMapsConsent
			}).then(res => {
				setTimeout(() => {
					this.savingPreferences = false
					this.preferencesSaved = true
				}, 250)
			})
		}
	},

	mounted() {
		this.$store.state.loading = true

		axios.get(this.$apiUrl + '/api/data', {params: {slug: this.$route.params.slug}}).then(res => {
			if (res.data.endUser?.contact_preference === null || res.data.endUser?.contact_preference.length === 0) {
				if (res.data.endUser.email) {
					this.preference.email = true
				}

				if (res.data.endUser.phone) {
					this.preference.phone = true
				}
			}

			if (res.data.endUser?.contact_preference?.includes('email')) {
				this.preference.email = true
			}

			if (res.data.endUser?.contact_preference?.includes('phone')) {
				this.preference.phone = true
			}

			if (res.data.endUser?.googleMapsConsent !== null) {
				this.preference.googleMapsConsent = res.data.endUser?.googleMapsConsent
			}

			this.scrubAt = res.data.scrub_at
			this.policy = res.data.gdprPolicy?.gdpr
			this.endUser = res.data.endUser
		    this.$store.state.translations = res.data.translations
		    this.$store.state.loading = false
		})
	}
}
</script>
